import * as React from 'react';
import { CheckboxButton } from '@cian/ui-kit';
import { ILocation } from '../../../../../types/location';
import * as styles from './styles.css';

export interface IRegionSpecialsDesktopProps {
  locations: ILocation[];
  selectedLocationId: number;

  onLocationSelect(location: ILocation): void;
}

export const SpecialRegionsDesktop: React.FC<IRegionSpecialsDesktopProps> = props => {
  const { locations, onLocationSelect, selectedLocationId } = props;

  return (
    <div className={styles['container']}>
      {locations.map(location => (
        <div key={location.id} className={styles['item']}>
          <CheckboxButton
            label={location.displayName}
            defaultChecked={selectedLocationId === location.id}
            onClick={() => onLocationSelect(location)}
          />
        </div>
      ))}
    </div>
  );
};

SpecialRegionsDesktop.displayName = 'SpecialRegionsDesktop';
